import { Asset, Fixture } from '@graphql/index';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ContentfulLogo } from '@stadionhq-v3/contentful-ui';
import { assetTransform } from '../transforms/components/atoms/asset.transform';

export const getClubCrest = (
  club:
    | CleanContentful<Fixture>['homeClub']
    | CleanContentful<Fixture>['awayClub'],
  fallbackClubCrest?: CleanContentful<Asset>
) => {
  const logoAvailable = club?.clubCrestInverse || club?.clubCrest;

  return logoAvailable ? (
    <ContentfulLogo {...logoAvailable} width={80} height={80} />
  ) : fallbackClubCrest ? (
    <ContentfulLogo
      {...assetTransform(fallbackClubCrest)}
      width={80}
      height={80}
    />
  ) : undefined;
};
